import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function DocumentClaimsChunk({ chunk }) {
  const regxsToRemove = [/<Desc\/Clms.*?>/g];
  return <InnerHTML tag="span" className="claims-chunk" html={chunk} regxsToRemove={regxsToRemove} />;
}

DocumentClaimsChunk.propTypes = {
  chunk: PropTypes.string.isRequired,
};

export default DocumentClaimsChunk;
